export default __webpack_public_path__ + "static/media/somwarpet.65e9fa95.jpg";